<template>
    <div class="p-5 darker">

        <div class="row mt-5">
            <div class="col-md-8 border-bottom-medium mb-4">
                <div class="darker font-weight-600">Invoice Settings</div>
                <div class="darker fs-small">VAT, System Integration, Invoice details.</div>
            </div>

            <div class="col-md-8 mb-4">
                <div class="row">
                    <div class="col-md-6">
                        <label class="full">
                            VAT ID
                            <input type="text" class="bg-lighter" v-model="invoices.vatID">
                        </label>
                    </div>
                </div>
            </div>

            <div class="col-md-8 mb-4">
                <div class="row">
                    <div class="col-md-6 d-flex flex-row align-items-center justify-content-between">
                        <span>Connect with ZRest invoice system</span>
                        <toggle-button :value="true" v-model="invoices.connectZRest" :sync="true" :labels="{checked: 'YES', unchecked: 'NO'}"/>
                    </div>
                </div>
            </div>

            <div class="col-md-8 mb-4">
                <div class="row">
                    <div class="col-md-6">
                        <label class="full">
                            API - KEY
                            <input type="text" class="bg-lighter" :disabled="!invoices.connectZRest" v-model="invoices.apiKey">
                        </label>
                    </div>
                </div>
            </div>

        </div>

        <div class="col-md-12 text-right">
            <input type="submit" value="Save" class="btn widest ml-auto" @click="save">
        </div>

    </div>
</template>

<script>
    import extendedVSelect from '@/extends/vue-select'
    import {mapGetters, mapActions} from 'vuex'

    export default {
        data: function() {
            return {
            }
        },
        methods:{
            save: function(){
                this.$emit('save');
            }
        },
        props:['invoices'],
        components:{
            vSelect: extendedVSelect
        }
    }
</script>

<style scoped lang="scss">
</style>



// WEBPACK FOOTER //
// TabInvoices.vue?d5170dc2